export const COMMUNICATION_GRAPH_DRAFT_MESSAGE = 'edinshall.communication.graph-draft' as const;

export interface CommunicationGraphDraftAttachment {
  name: string;
  contentType: string;
  size: number;
  base64: string;
}

export interface CommunicationGraphDraftRequest {
  kind: typeof COMMUNICATION_GRAPH_DRAFT_MESSAGE;
  phase: 'request';
  nonce: string;
  tenantId: string;
  subject: string;
  plainText: string;
  html?: string;
  recipients: string[];
  deepLinkUrl: string;
  attachments: CommunicationGraphDraftAttachment[];
}

export interface CommunicationGraphDraftReady {
  kind: typeof COMMUNICATION_GRAPH_DRAFT_MESSAGE;
  phase: 'ready';
  nonce: string;
}

export interface CommunicationGraphDraftResult {
  kind: typeof COMMUNICATION_GRAPH_DRAFT_MESSAGE;
  phase: 'result';
  nonce: string;
  status: 'prepared' | 'fallback' | 'cancelled' | 'failed';
  error?: string;
}

export type CommunicationGraphDraftBridgeMessage =
  | CommunicationGraphDraftRequest
  | CommunicationGraphDraftReady
  | CommunicationGraphDraftResult;
